import React from 'react'
import { APP_NAME } from 'configs/AppConfig';

import IntlHOC from 'components/util-components/IntlMessage/intl_hoc';

const Footer = (props) => {
	const { intl } = props;
	return (
		<footer className="footer">
			<span></span>
			<div>
				Copyright  &copy;  {`${new Date().getFullYear()}`}
				<span className="mx-2 font-weight-semibold">{APP_NAME}</span>
				{intl.formatMessage({ id: "footer" })}
			</div>
		</footer>
	)
}


export default IntlHOC(Footer);
